/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DefaultWebhookParams } from './DefaultWebhookParams';
import type { GoogleChatWebhookParams } from './GoogleChatWebhookParams';

export type AlertingHookDto = {
    createdBy?: string;
    createdDate?: number;
    externalHook: string;
    id: string;
    lastModifiedDate?: number;
    modifiedBy?: string;
    name: string;
    params?: (DefaultWebhookParams | GoogleChatWebhookParams);
    type: AlertingHookDto.type;
};

export namespace AlertingHookDto {

    export enum type {
        SLACK = 'SLACK',
        MAIL = 'MAIL',
        MS_TEAMS = 'MS_TEAMS',
        WEBHOOK = 'WEBHOOK',
    }


}
